/** Копировать в буфер обмена
 * @param button кнопка копирования
 */
export async function copy(button: HTMLElement) {
  let text = button.dataset.copy

  if (!text) {
    const selector = button.dataset.copyTarget
    if (!selector) return

    const target = document.querySelector<HTMLElement>(selector)
    text = target?.textContent ?? ''
  }

  if (!text) return

  await navigator.clipboard.writeText(text)
}
